import { render } from "./AttributeChart.vue?vue&type=template&id=24dc8b6e"
import script from "./AttributeChart.vue?vue&type=script&lang=js"
export * from "./AttributeChart.vue?vue&type=script&lang=js"

import "./AttributeChart.vue?vue&type=style&index=0&id=24dc8b6e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__